'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_START = exports.FETCH_START = 'AOR/FETCH_START';
var FETCH_END = exports.FETCH_END = 'AOR/FETCH_END';
var FETCH_ERROR = exports.FETCH_ERROR = 'AOR/FETCH_ERROR';
var FETCH_CANCEL = exports.FETCH_CANCEL = 'AOR/FETCH_CANCEL';


//////////////////
// WEBPACK FOOTER
// ./~/admin-on-rest/lib/actions/fetchActions.js
// module id = 111
// module chunks = 0